// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GJWZp0QjYJws1tYwKEvJ {
  padding-left: 12px;
  padding-right: 12px;
  max-width: 1160px;
}
`, "",{"version":3,"sources":["webpack://./client/src/components/UI/Container/Container.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".container {\n  padding-left: 12px;\n  padding-right: 12px;\n  max-width: 1160px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GJWZp0QjYJws1tYwKEvJ`
};
export default ___CSS_LOADER_EXPORT___;
